import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { staticPermissionData } from "helpers/GeneralHelper";
import { useNavigate } from "react-router-dom";
import { loginData } from "model/LoginModel";
import { fetchJobCategoryTableAndFilterSchema } from "model/CategoryModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";


const JobCategoryContext = createContext();

export const JobCategoryProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userData, setUserData] = useState();
    const navigate = useNavigate();
    const [permissionData, setPermissionData] = useState();
    const [jobCategoryContextData, setJobCategoryContextData] = useState();
    const [jobCategoryVersion, setJobCategoryVersion] = useState();


     // 🔹 Fetch home page data once
  const fetchJobCategoryContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:jobCategory", () =>
        fetchJobCategoryTableAndFilterSchema([])
      );
      if (response?.success) {
        setJobCategoryContextData(response?.data);
        setJobCategoryVersion(response?.schemaVersion);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };



    // 🔹 Fetch home page data once

    useEffect(() => {
        const fetchAll = async () => {
            await Promise.all([]);
        };
        fetchAll();
    }, []);

    return (
        <JobCategoryContext.Provider value={{ fetchJobCategoryContextData, jobCategoryContextData, permissionData, loading, error, jobCategoryVersion }}>
            {children}
        </JobCategoryContext.Provider>
    );
};

export const useJobCategoryContext = () => useContext(JobCategoryContext);
